import React from 'react';
import {useTranslation} from 'react-i18next';

import styles from './modal-base.module.css';

const currencyMock = [
  {
    title: 'AL FARDAN EXCHANGE CO.',
    phone: '4440 8204'
  },
  {
    title: 'GULF EXCHANGE CO.',
    phone: '4438 3222'
  },
  {
    title: 'HABIB QATAR INTERNATIONAL EXCHANGE CO.',
    phone: '4442 4373'
  },
  {
    title: 'AL ZAMAN EXCHANGE CO.',
    phone: '4444 1448'
  },
  {
    title: 'DOHA EXCHANGE CO.',
    phone: '4442 4520'
  },
  {
    title: 'LULU EXCHANGE CO.',
    phone: '4444 1448'
  },
  {
    title: 'NATIONAL EXCHANGE CO.',
    phone: '4441 2148'
  },
  {
    title: 'AL MANA EXCHANGE CO.',
    phone: '4442 4226'
  },
  {
    title: 'EASTERN EXCHANGE CO.',
    phone: '4441 2655'
  },
  {
    title: 'CITY EXCHANGE CO.',
    phone: '4443 0344'
  },
  {
    title: 'LARI EXCHANGE CO.',
    phone: '4441 9030'
  },
  {
    title: 'ARABEAN EXCHANGE CO.',
    phone: '4443 8300'
  },
  {
    title: 'ISLAMIEC EXCHANGE CO.',
    phone: '4442 2718'
  },
  {
    title: 'TRUST EXCHANGE CO.',
    phone: '4435 2055'
  },
  {
    title: 'AL MIRQAB EXCHANGE CO.',
    phone: '4442 3715'
  },
  {
    title: 'ALSADD EXCHANGE CO.',
    phone: '4432 3337'
  },
  {
    title: 'AL-JAZEERA EXCHANGE',
    phone: '4436 3595'
  },
  {
    title: 'AL DAR EXCHANGEWORKS CO.',
    phone: '4442 3715'
  },
  {
    title: 'QATAR-UAE EXCHANGE',
    phone: '4443 6804'
  },
  {
    title: 'TRAVELEX QATAR',
    phone: '4443 2043'
  }
];

const CurrencyModal = () => {
  const {t} = useTranslation();

  return (
    <>
      <h3 className={styles.modalTitle}>
        {t('fifa2022.useFullMaterialsWidget.currency.modal.title')}
      </h3>
      <p className={styles.modalText}>
        {t('fifa2022.useFullMaterialsWidget.currency.modal.text1')}
      </p>
      <p className={styles.modalText}>
        {t('fifa2022.useFullMaterialsWidget.currency.modal.text2')}
      </p>
      <p className={styles.modalText}>
        {t('fifa2022.useFullMaterialsWidget.currency.modal.text3')}
      </p>
      <div className={styles.modalTable}>
        <div className={styles.tableHead}>
          <span>
            {t('fifa2022.useFullMaterialsWidget.currency.modal.columnTitle1')}
          </span>
          <span>
            {t('fifa2022.useFullMaterialsWidget.currency.modal.columnTitle2')}
          </span>
        </div>
        <div className={styles.tableBody}>
          {currencyMock.map(currencyItem => (
            <div key={currencyItem.title} className={styles.tableItem}>
              <span>{currencyItem.title}</span>
              <span className={styles.phoneNumber}>{currencyItem.phone}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CurrencyModal;

